import React from "react";

const parseOrNot = (tag) => {
  if (tag === 'deposit' || tag === 'withdrawal') {
    return true;
  }
  return false;
}

const parseHighlightText = (text) => {
  return text.split(/(::\S+)/g).map((part, index) => {
    if (part.startsWith("::")) {
      const value = part.slice(2);
      return (
        <span key={index} className="highlight">
          {value}
        </span>
      );
    }
    return part;
  });
};

export { parseOrNot, parseHighlightText };